module.exports = __webpack_public_path__ + "static/media/wizafy-playlists.937005c6.jpg";